<template>
    <div class="render_draw">
      <span v-if="!drawFlag" @click="drawFlag=!drawFlag" style="display: flex;align-items: center"><Icon style="margin-right:2px;color:rgb(238, 201, 0);font-size:16px;" type="social-usd"></Icon>{{statusName}}</span>
      <div v-else>
        <Poptip trigger="click" v-model="drawFlag">
          <span style="display: flex;align-items: center"><Icon style="margin-right:2px;color:rgb(238, 201, 0);font-size:16px;" type="social-usd"></Icon>{{statusName}}</span>
          <div slot="content">
            <Button type="primary" @click="pushKz">领取客资</Button>
          </div>
        </Poptip>
      </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: "render-draw",
    props:{
      rowData:{
        type:Object,
      },
      statusName:{
        type:String,
      },
    },
    computed:{
      ...mapGetters(['userInfo'])
    },
    data(){
      return{
        drawFlag:false,
      }
    },
    methods:{
      pushKz(){
        this.$http.get('/app/pc_receive',{
          params:{
            staffId:this.userInfo.id,
            kzId:this.rowData.kzid,
          }
        }).then(data=>{
          if(data.code === 100000){
            this.$Message.success(data.msg)
            this.drawFlag = !this.drawFlag
            this.$bus.$emit('pull-kz-data')
          }else{
            this.$Message.error(data.msg)
          }
        })
      }
    }
  }
</script>

<style lang="less">
  .render_draw{
    span{
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/render-components/render-draw.vue